const child_care = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1_33128)">
      <path d="M12 12C12 9 14.5 6.5 17.5 6.5C20.5 6.5 23 9 23 12H12ZM12 12C12 15 9.5 17.5 6.5 17.5C3.5 17.5 1 15 1 12H12ZM12 12C9 12 6.5 9.5 6.5 6.5C6.5 3.5 9 1 12 1V12ZM12 12C15 12 17.5 14.5 17.5 17.5C17.5 20.5 15 23 12 23V12Z" fill="black" />
    </g>
    <defs>
      <clipPath id="clip0_1_33128">
        <rect width="24" height="24" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);
export default child_care;
